import {combineReducers} from 'redux';



import {fileSearchReducer} from './fileSearch'
import {getCusomterSessionReducer } from './getSessionsCustomers';
const reducer = combineReducers({
   getCusomterSessionReducer,fileSearchReducer 
    });
    
    export default reducer;
